import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {SessionService} from "./session.service";

@Injectable({
    providedIn: 'root'
})
export class AuthentificationService {
    host;
    email: string;
    profil: string;
    id;
    permissions: Array<string>;

    constructor(private http: HttpClient, private sessionService: SessionService) {
    }

    public login(data) {
    }

    public getUtilisateurByEmail(email) {
    }

    public getAffectationsListByUser(uuidUser: string) {
    }

    public forgottenPassword(email: string) {
    }


    isSuperviseur() {

    }

    public isAutheticated(): boolean {
        return this.isConnected();
    }


    public displayAllowed(ecran) {

    }

    public getComponentByProfil(uuidProfil: string) {
    }

    public getIsDirector(email: string) {
    }

    public getIPAddress() {
    }

    public setIsAdmin(isAdmin: boolean): void {
        this.sessionService.setIsAdmin(isAdmin);
    }

    public isAdmin(): boolean {
        return this.sessionService.isAdmin();
    }

    public saveToken(jwt: string): void {
        this.sessionService.setBearerToken(jwt);
    }

    public isConnected(): boolean {
        return this.sessionService.getBearerToken() !== null && this.sessionService.getBearerToken() !== 'null';
    }
}